import { render } from "./LatestNews.vue?vue&type=template&id=6b3f38ce&ts=true"
import script from "./LatestNews.vue?vue&type=script&lang=ts"
export * from "./LatestNews.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__